export interface CaptionTimingQualityInput {
  captionTimingPolicyVersion?: number | null;
  captionTimingClass?: string | null;
  captionAlignmentMode?: string | null;
  captionTimingFallbackUsed?: boolean | null;
}

/**
 * Legacy caption artifacts keep their historical behavior. Timing-policy v2
 * enables highlighting only when word cues come from verified forced alignment.
 */
export const isCaptionHighlightTimingEligible = (
  timing: CaptionTimingQualityInput | null | undefined,
): boolean => {
  if (!timing || (timing.captionTimingPolicyVersion ?? 1) < 2) return true;
  if (timing.captionTimingFallbackUsed === true) return false;

  return (
    timing.captionTimingClass === 'forced_aligned' &&
    !['stt_transcript', 'segment_timing', 'synthetic', 'fallback'].includes(
      timing.captionAlignmentMode ?? '',
    )
  );
};
